import { render, staticRenderFns } from "./GLTransaction.vue?vue&type=template&id=811a9fe8"
import script from "./GLTransaction.vue?vue&type=script&lang=js"
export * from "./GLTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports